export default "__VITE_ASSET__kSHl1FSV__"